import * as _ from 'lodash';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { EventPageData } from 'app/event-page/models/event-page-data.model';
import { EventPageService } from 'app/event-page/services/event-page.service';

@Component({
  selector: 'app-event-page-navbar',
  templateUrl: './event-page-navbar.component.html',
  styleUrls: ['./event-page-navbar.component.scss']
})
export class EventPageNavbarComponent implements OnInit {
  
  @ViewChild('navbarNav') navbarNav: ElementRef;

  @Input() eventPageConfig = null;

  public navStyles = {};
  public navRegularLinkStyles = {};
  public classes = {};

  public customColorTheme = null;
  public organization = null;
  public eventPageData = null;
  public innerWidth = 0;
  
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  constructor(
    private eventPageService: EventPageService,
  ) { }


  ngOnInit(): void {
    this.customColorTheme = _.get(this.eventPageConfig, 'customColorTheme', null);
    this.organization = _.get(this.eventPageConfig, 'orgInfo', null);

    this.eventPageData = new EventPageData(this.eventPageConfig);

    this.innerWidth = window.innerWidth;

    this.navStyles = {
      'background-color' : this.customColorTheme.getNavBgColor()
    };
    
    this.navRegularLinkStyles = {
      'color' : this.customColorTheme.getNavRegularLinkColor()
    };

    const theme = this.eventPageService.themes[this.eventPageConfig.templateType];
    switch (theme) {
      case 'ocean':
      case 'holidays':
      case 'purple':
        this.classes = {
          'navbar-dark': true,
          'bg-dark': true
        }
        break;
      default:
        this.classes = {
          'navbar-light': true,
          'bg-light': true
        }
    }
  }

  toggleNavbar() {
    this.navbarNav.nativeElement.classList.toggle('collapse');
  }
}
